import * as React from 'react';
import { MobileLayout } from '../../../components/Layout';
import { Layout } from '../../../components/PageLayout';
import { HeroContainer } from '../../Hero';
import { OnboardingModalContainer } from '../../Onboarding';
import { JournalSidebarLoader } from '../../JournalSidebar';
import { ProfitContainerLoad } from '../../Profit';

export const MobileView: React.FC = () => {
  return (
    <>
      <MobileLayout>
        <HeroContainer />

        <Layout>
          <ProfitContainerLoad />
          <JournalSidebarLoader />
        </Layout>
      </MobileLayout>

      <OnboardingModalContainer />
    </>
  );
};
